import Cross from '@assets/svg/icons/cross.svg'
import Search from '@assets/svg/icons/search.svg'
import clsx from 'clsx/lite'
import React, {
  type Dispatch,
  type SetStateAction,
  useEffect,
  useRef,
} from 'react'

type Props = {
  inputValue: string
  setInputValue: Dispatch<SetStateAction<string>>
  isLightMode: boolean
  isLoading: boolean
}

const SearchInput = ({
  inputValue,
  setInputValue,
  isLightMode,
  isLoading,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>()

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <div className="flex flex-row items-center gap-4 pr-8">
      <Search
        className={isLightMode ? 'fill-black-50' : 'fill-white-50'}
        height={16}
        width={16}
      />
      <input
        ref={inputRef}
        placeholder="Rechercher"
        type="text"
        value={inputValue}
        className={clsx(
          'font placeholder:text-amplification-black-premium/20 group-[.is-dark-mode]/menu:text-white-50 group-[.is-dark-mode]/menu:placeholder:text-white-50/20 flex-1 bg-transparent text-[22px] font-normal! focus:outline-none',
          isLoading && 'animate-pulse-slowly'
        )}
        onChange={(e) => {
          setInputValue(e.target.value)
        }}
      />
      <button
        type="button"
        className={clsx(
          'group-[.is-dark-mode]/menu:bg-white-50 flex h-4 w-4 items-center justify-center rounded-full bg-[#003500] opacity-0 transition-opacity',
          inputValue && 'opacity-100'
        )}
        onClick={() => {
          setInputValue('')
        }}
      >
        <Cross
          className={isLightMode ? 'fill-white-50' : 'fill-black-50'}
          height={8}
          width={8}
        />
      </button>
    </div>
  )
}

export default SearchInput
